<template>
    <div class="loader loaderPageDetails" v-show="this.isLoading"></div> 
    <HeroSlider v-show="!this.isLoading"
        :tipoElemento = "'NUB_SLIDER_ORDERFORM'"
    />
    <section class="OrderForm" v-show="!this.isLoading">
        <div class="Box">
            <div class="Frame">
                <div class="OrderFormTableBox">
                    <div class="OrderFormTableTexe">
                        <div class="Bookmark">
                            <span>{{ risorse['orderForm.title'] }}</span>
                        </div>
                        <div v-html="risorse['orderForm.body']"></div>
                    </div>
                    <div class="OrderFormTable">
                        <div class="OrderFormTableIndex">
                            <!--<div class="OrderFormTableindexData">
                                <h3>{{ testaAzienda?.RagioneSociale }}</h3>
                                <span>
                                    {{ risorse['codiceCliente'] }}:<strong> &nbsp;{{testaAzienda?.CodiceCliente}}</strong>
                                </span>
                            </div>-->
                            <div class="Button CustomColor Iconed Shopper Big right-align">
                                <a @click="addToOrder()">{{ this.risorse['AggiungiCarrello'] }}</a>
                            </div>
                            <div id="app-container" class="orderFormContainer">
                                <DxDataGrid
                                    ref="myDataGrid"
                                    class="dx-data-grid"
                                    :data-source="ItemsList"
                                    :allow-column-reordering="true"
                                    key-expr="CompositeKey"
                                    :row-alternation-enabled="true"
                                    :allow-column-resizing="true"
                                    column-resizing-mode="widget"
                                    :focused-row-enabled="true"
                                    :selected-row-keys="SelectedRowKeys"
                                    @exporting="onExporting"
                                    @onRowPrepared="onRowPrepared"
                                    @row-updated="onRowUpdated"
                                >
                                    <DxFilterRow :visible="true" />
                                    <DxHeaderFilter :visible="true" />
                                    <DxSelection
                                        mode="multiple"
                                        show-check-boxes-mode="always"
                                    />
                                    <DxExport
                                        :enabled="true"
                                        :allow-export-selected-data="true"
                                    />
                                    <DxPager
                                        :show-page-size-selector="true"
                                        :allowed-page-sizes="[10, 20, 50, 100]"
                                        :show-navigation-buttons="true"
                                    />
                                    <DxEditing
                                        mode="cell"
                                        :allow-updating="true"
                                    />
                                    <DxColumn data-field="Catalogo"
                                        :allow-editing="false"
                                        :caption="risorse['catalogo']"
                                        data-type="string"
                                    />
                                    <DxColumn data-field="CodiceGruppo"
                                        :allow-editing="false"
                                        :caption="risorse['CodiceGruppo']"
                                        data-type="string"
                                    />
                                    <DxColumn data-field="DescrView"
                                        :allow-editing="false"
                                        :caption="risorse['descrizione']"
                                        data-type="string"
                                    />
                                    <DxColumn data-field="CodiceEan"
                                        :allow-editing="false"
                                        :caption="risorse['codiceEAN']"
                                        data-type="string"
                                    />
                                    <DxColumn data-field="CodiceArticolo"
                                        :allow-editing="false"
                                        :caption="risorse['codicePadre']"
                                        data-type="string"
                                    />
                                    <DxColumn data-field="StockDescr"
                                        :allow-editing="false"
                                        :caption="risorse['stock']"
                                    />
                                    <DxColumn data-field="DtNuoviArrivi"
                                        :allow-editing="false"
                                        :caption="risorse['TabVarDtNewArr']"
                                    />
                                    <DxColumn data-field="PzConf"
                                        :allow-editing="false"
                                        :caption="risorse['pzConf']"
                                    />
                                    <DxColumn data-field="QuantitaOF"
                                        :allow-editing="true"
                                        :onRowUpdated ="onRowUpdated()"
                                        :caption="this.risorse['quantita']"
                                        :cellTemplate="QtyCellStyle"
                                        :sort-order="'desc'"
                                        :sort-index=0
                                        :cell-template = "highlightCell"
                                    />
                                    <DxColumn 
                                        data-field="PrezzoAgente"
                                        :caption="risorse['prezzoAgente']"
                                        :allow-editing="false"
                                        dataType="number"
                                        :format="{
                                            type: 'currency',
                                            currency: 'EUR',
                                            precision: 2
                                        }"
                                    />
                                    <DxColumn data-field="PrezzoNetto"
                                        :allow-editing="false"
                                        :caption="risorse['prezzoNetto']"
                                        dataType="number"
                                        :format="{
                                            type: 'currency',
                                            currency: 'EUR',
                                            precision: 2
                                        }"
                                    /><!--
                                    <DxColumn data-field="ScontoLogistico"
                                        :allow-editing="false"
                                        :caption="risorse['scontoLogistico']"
                                        :format="{
                                            type: 'percent',
                                            precision: 2
                                        }"
                                    />-->
                                    <DxColumn data-field="Segmento"
                                        :allow-editing="false"
                                        :caption="risorse['Segmento']"
                                    />
                                    <DxColumn data-field="PrezzoTotaleOF"
                                        
                                        :allow-editing="false"
                                        :caption="risorse['totaleRiga']"
                                        dataType="number"
                                        :format="{
                                            type: 'currency',
                                            currency: 'EUR',
                                            precision: 2
                                        }"
                                    />
                                    <DxColumn data-field="Attributo1"
                                        :allow-editing="false"
                                        :caption="risorse['attributo1']"
                                    />
                                    <DxColumn data-field="Attributo2"
                                        :allow-editing="false"
                                        :caption="risorse['attributo2']"
                                    />
                                    <DxSummary>
                                        <DxTotalItem
                                            column="QuantitaOF"
                                            summary-type="sum"
                                            show-in-column="QuantitaOF"
                                            alignment="right"
                                            :display-format="risorse['numeroPezzi'] + ' {0}'"
                                        />
                                        <DxTotalItem
                                            column="PrezzoTotaleOF"
                                            summary-type="sum"
                                            show-in-column="PrezzoTotaleOF"
                                            alignment="right"
                                            :display-format="risorse['totArts'] + ' {0}'"
                                            :customize-text="formatQuantity"
                                        />
                                    </DxSummary>
                                </DxDataGrid>
                            </div>
                        </div>
                        <div class="OrderFormTableButton right-align">
                            <div class="Button CustomColor Iconed Shopper Big">
                                <a @click="addToOrder()">{{ this.risorse['AggiungiCarrello'] }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { 
        DxDataGrid,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxExport,
        DxSelection,
        DxTotalItem,
        DxSummary,
        DxFilterRow,
        DxPager
    } from 'devextreme-vue/data-grid';
import HeroSlider from '@/components/HeroSlider.vue';
import {risorseMixin, dateMixin} from '@/mixin.js';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import OrderFormService from '@/services/orderForm.service.js';
import CartService from '@/services/cart.service.js';
import AddCartResponse from '@/models/AddCartResponse.model.js';

export default {
    name:"OrderForm",
    mixins:[risorseMixin, dateMixin],
    data(){
        return{
            ordine: null,
            ItemsList: [],
            ordini:[],
            testaAzienda:{},
            pageIndex: 1,
            isLoading: false,
            idCarrello:null
        }
    },
    components:{
        DxDataGrid,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxExport,
        DxSelection,
        DxTotalItem,
        DxSummary,
        DxPager,
        DxFilterRow,
        HeroSlider
    },
    computed:{
        CodLingua: function(){
            return this.$store.getters.getUtente?.Lingua;
        },
        SimboloValuta: function(){
            return (this.$store.getters.getOrdine?.SimboloValuta ?? ' ');
        },
        SelectedRowKeys: function(){
            if(this.ItemsList != null && this.ItemsList.length > 0){
                return (this.ItemsList.filter(x => x.QuantitaOF > 0).map(x => x.CompositeKey) ?? []) ;
            }else{
                return [];
            }
        }
    },
    mounted(){
        this.idCarrello = this.$store.getters.getCarrello?.Testata.IdCarrello;
        if(this.idCarrello != null && this.idCarrello != undefined){
            this.getArticoli();
        }
    },
    methods:{
        getArticoli: function(){
            this.isLoading = true
            OrderFormService.getArticoliOF(this.$store.getters.getToken, this.idCarrello, this.$store.getters.getLingua).then(
                (data) => {
                    this.isLoading = false;
                    if(data != null && data != undefined){
                        if(data != null && data.length > 0){
                            this.ItemsList = data;
                            this.ItemsList.forEach(x => {
                                if (x) {
                                    x.ScontoLogistico = x.ScontoLogistico / 100;
                                    x.DescrView = (x.Descrizione ?? x.DescrizioneArticolo) + ' ' + x.DescrizioneColore + ' ' + x.DescrizioneTaglia;
                                    x.StockDescr = this.DecodStock(x.Stock);
                                    x.Segmento = x.Segmento ?? 'none';
                                    x.Attributo1 = x.ChkRepriced ? 'Repriced' : 'none';
                                    x.Attributo2 = x.ChkNovita ? 'New' : 'none';
                                    x.DtNuoviArrivi = this.formatDateNoOre(x?.DtNuoviArrivi) ?? '-';
                                    x.CompositeKey = `${x.CodiceArticolo}_${x.Catalogo}`;
                                }
                            });
                        }
                    }
            });
        },
        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('ArticoliOrderForm');

            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
                });
            });

            e.cancel = true;
        },
        onRowUpdated: function(e){
            this.qtaMultiplo(e);
            if(e != null && e != undefined && e?.data != null && e?.data != undefined && e.data?.QuantitaOF > 0){
                let prezzoNetto = e.data.PrezzoNetto;
                if(!this.qtaMultiplo){
                    prezzoNetto = prezzoNetto - (e.data.PrezzoNetto * (e.data.ScontoLogistico / 100));
                }
                let v = {
                    CodiceArticolo: e.data.CodiceArticolo,
                    Quantita: e.data.QuantitaOF,
                    PrezzoNetto: prezzoNetto,
                    PrezzoListino: e.data.PrezzoAgente,
                    Sconto1: e.data.Sconto1,
                    Sconto2: e.data.Sconto2,
                    Sconto3: e.data.Sconto3,
                    Sconto4: e.data.Sconto4,
                    Sconto5: e.data.Sconto5,
                    ValoreSconto1: e.data.ValoreSconto1,
                    ValoreSconto2: e.data.ValoreSconto2,
                    ValoreSconto3: e.data.ValoreSconto3,
                    ValoreSconto4: e.data.ValoreSconto4,
                    ValoreSconto5: e.data.ValoreSconto5,
                    Catalogo: e.data.Catalogo,
                    DescrizioneArticolo: e.data.Descrizione,
                    DescrizioneTaglia: e.data.DescrizioneTaglia,
                    DescrizioneColore: e.data.DescrizioneColore,
                    UrlImmagine: e.data.UrlImmagine,
                    Valuta: this.codiceValuta,
                    PrezzoAgente: e.data.PrezzoAgente,
                    IsBackorder: 0,
                    VenditaSoloMultipli: e.data.VenditaSoloMultipli,
                    Multipli: e.data.Multipli,
                    FromOF: 1
                };
                this.$store.commit('updateRow', v);
            }
        },
        onRowPrepared: function(e){
            e.rowElement.classList.add('orderFormRow');
            if(this.qtaMultiplo(e)){
                e.rowElement.classList.add('ScontoLogistico')
            }
        },
        qtaMultiplo: function(e){
            let a = ((e?.data?.QuantitaOF > 0 ) && (!e?.data?.PrezzoBloccato) && (e?.data?.PzConf > 1) && (e?.data?.QuantitaOF) && (e?.data?.QuantitaOF > 1) &&(e.data?.QuantitaOF % e.data?.PzConf == 0));
            return a;
        },
        addToOrder: function(){
            if(!this.$store.getters.getCarrelloTmp || this.$store.getters.getCarrelloTmp.Righe.length == 0){
                return;
            }
            this.isLoading = true;
            this.$store.dispatch({
                type: 'setCarrello',
                token: this.$store.getters.getToken,
                isBackorder: 0
            }).then(() =>{
                this.isLoading = false;
                this.getArticoli();
                CartService.getCartByUsername(this.$store.getters.getToken).then(
                    (data) => {
                        if(data){
                            let responseCart = new AddCartResponse();
                            Object.assign(responseCart, data);
                            if(responseCart.Status == 1){
                                this.$store.commit('resetCarrelloTmp');
                                this.$store.commit('updateCarrello', responseCart.Carrello);
                                this.$store.commit('setChkSeasonalOrders',(responseCart.Carrello?.ChkSeasonalOrder ?? false));
                                this.responseCart = 1;
                            }
                        }
                    }
                ); 
            });
        },
        DecodStock(val){
            if(val != null && val != undefined){
                if(val == 0)
                    return "Out of Stock";
                else if(val == 1)
                    return "Low Stock";
                else if(val == 2)
                    return "In Stock";

                else return "No info";
            }
        },
        QtyCellStyle(container, options) {
            $(container).addClass('QtyCellStyle').text(options.value);
        },
        formatQuantity({ value }) {
            return this.risorse['totArts'] + this.SimboloValuta +' '+ value.toFixed(2);
        },
        highlightCell(cellElement, cellInfo) {
            cellElement.innerHTML = cellInfo.value;
            cellElement.classList.add('highlight-column');
        }
    }
}
</script>

<style>
.orderFormRow{
    border-bottom:1px solid #e7e7e7;
    font-weight:400 !important;
    color:var(--typographylightcolor) !important;
    padding-top:18px !important;
    padding-bottom:18px !important;
}

.QtyCellStyle{
    box-sizing: border-box !important;
}

.ScontoLogistico{
    text-decoration: solid !important;
    font-weight:bold !important;
}

#app-container.orderFormContainer {
    overflow: auto;
    max-width: 100%;
}

.OrderFormTable {
    table-layout: fixed;
    width: 100%;
}

.OrderFormTable th, .OrderFormTable td {
    white-space: nowrap;
}
.dx-data-grid {
    max-width: 100%;
    max-height: 100%; 
    overflow: auto;
}

.highlight-column {
    font-weight: bold;
    background-color: #fce200 !important;
    color: #000 !important;
}
.right-align {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 3rem;
    margin-top: 3rem;
}
</style>